
export default class ScrollView{

    constructor(){
        this._init();
    }

    _init(){
        this.$acmncopy = null;
        this.$wovn = null;
        this.$thumblist = document.querySelector('.js-thumblist');

        this._onScroll = this._onScroll.bind(this);

        const mql = window.matchMedia("(max-width: 768px)");
        mql.addEventListener('change', (e)=>{
            if(e.matches) this._addScrollListener();
            else this._removeScrollListener();
        });
        if(mql.matches) this._addScrollListener();
    }


    _addScrollListener() {
        window.addEventListener('scroll', this._onScroll);
        this._onScroll();
    }

    _removeScrollListener() {
        window.removeEventListener('scroll', this._onScroll);

        if(!this.$wovn) this.$wovn = document.querySelector('#wovn-translate-widget');
        this.$wovn.removeAttribute('style');
    }


    _onScroll(){
        if(!this.$acmncopy) this.$acmncopy = document.querySelector('#acmncopy');
        if(!this.$wovn) this.$wovn = document.querySelector('#wovn-translate-widget');
        if(!this.$acmncopy || !this.$wovn) return;
        this._update();
    }

    _update(){
        const acommoncopyTop = this.$acmncopy.getBoundingClientRect().top;
        const wh = window.innerHeight;

        if(acommoncopyTop <= wh){
            const pos = `calc(25.3vw + ${wh - acommoncopyTop}px)`;
            this.$wovn.style.bottom = pos;
        }
        else{
            this.$wovn.style.bottom = '25.3vw';
        }

        this.ticking = false;
    }
}